import React, {Component} from 'react';
import Main from './js/components/Main';
import './css/login.css';
import 'core-js';

class App extends Component {
  render() {
    return (
        <Main />
    );
  }
}

export default App;
